import {spawn} from "redux-saga/effects";
import groupSaga from "./groups/sagas/groupSaga";
import usersSaga from "./users/sagas/usersSaga";

export default function* rootSaga() {
  yield spawn(groupSaga);
  yield spawn(usersSaga);
}
